import React, { useContext } from 'react';
import { AppContext } from '../../app.context.js';
import { useTour } from '../../TourContext.jsx';
import { useLocation } from 'react-router-dom';
import { checkIsActive } from '../../components/MainSidebar/rules';
import Header from '../../components/Header2';
import ResponsiveFooter from '../../components/ResponsiveFooter';
import { RouteContainer } from './style';
import { shouldShowComponent } from '../../rules';

const VisibilityWrapper = ({ children }) => {
  const location = useLocation();
  const { markingTourActive, markingTourStep, feedbackTourActive } = useTour() || {};

  const hideFooterRoutes = [
    '#/submissions',
    '#/getFeedback',
    '#/documents',
    '#/feedbackRequest/documentsReview',
    '#/feedbackHistory/documentsReview',
    // Teacher Loop (build flag on only): the gift pages are standalone
    // responsive pages, also on phones, with no app footer. (The flag literal
    // lets a flag-off build drop this: utils/teacherLoopGate.js.)
    ...(process.env.REACT_APP_TEACHER_LOOP === 'on'
      ? ['#/thanks/', '#/gift/']
      : []),
  ];
  const hideHeaderPaths = [
    '#/view/submissions',
    '#/submissions',
    '#/documents',
    // A bulk draft page renders its own Header2 (it titles itself with the
    // draft), exactly as /documents does. Without this the generic header
    // stacks on top of it — two identical bars, and the drafts sidebar starts
    // a header's height too far down.
    '#/drafts/',
    '#/feedbackRequest/documentsReview',
    '#/feedbackHistory/documentsReview',
    '#/markingTemplates',
    '#/tasks/',
    // Onboarding mirror pages that render their OWN Header2 (CreateNewTask at
    // /onboarding/new-task; FeedbacksRoot at /onboarding/documents|submissions).
    // Without these, VisibilityWrapper's generic <Header/> stacks on top of the
    // mirror's header → a doubled header bar. The marking/tools mirror pages
    // render no header of their own, so they intentionally keep this header.
    '#/onboarding/new-task',
    '#/onboarding/documents',
    '#/onboarding/submissions',
    // Teacher Loop (build flag on only): the Teacher Check pages render their
    // own Header2, as /view/submissions does; the gift pages (/thanks/<code>,
    // /gift/verify) have their own jeddle.com-style header.
    ...(process.env.REACT_APP_TEACHER_LOOP === 'on'
      ? ['#/check/', '#/thanks/', '#/gift/']
      : []),
  ];

  const showHeader = shouldShowComponent(hideHeaderPaths);
  const showFooter = shouldShowComponent(hideFooterRoutes);

  const showOnTop = (markingTourActive && markingTourStep >= 2 && markingTourStep <= 13);

  return (
    <div
      className="route-container"
      style={showOnTop ? {
        zIndex: 1002,
        position: 'relative',
        width: '100%',
        background: 'transparent'
      } : {}}
    >
      {showHeader && <Header />}
      {children}
      {showFooter && <ResponsiveFooter />}
    </div>
  );
};

export default VisibilityWrapper;
